module["exports"] = [
  "Снаб",
  "Торг",
  "Пром",
  "Трейд",
  "Сбыт"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/company/suffix.js
// module id = 1633
// module chunks = 0